import { changeTariffFromBackend } from '@entities/tariff/lib';
import { $api } from '@shared/api';
import { handleAxiosFetchErrorsSwal } from '@shared/helpers/fetchHelpers';
import { Status } from '@widgets/EstimateInformation/model/types/types';

export const updateEstimateStatus = async (newStatus: Status) => {
    // @ts-expect-error routable is provided by the legacy web shell.
    const url = routable.getRoute('updateEstimateStatus');

    const statusMapping = {
        [Status.DRAFT]: 'draft',
        [Status.ON_AGREEMENT]: 'on_agreement',
        [Status.IN_EXPLOITATIONS]: 'in_exploitations',
        [Status.COMPLETED]: 'completed',
    };

    try {
        // @ts-expect-error loader is provided by the legacy web shell.
        loader.show();
        const response = await $api.post(url, {
            status: statusMapping[newStatus],
        });

        return { data: response.data, updatedStatus: statusMapping[newStatus] };
    } catch (error) {
        const data = error?.response?.data;
        // @ts-expect-error loader is provided by the legacy web shell.
        loader.hide();
        if (data?.status === 'tariff-error' && data?.tariff_popup_url) {
            await changeTariffFromBackend(data.tariff_popup_url);
        } else {
            handleAxiosFetchErrorsSwal(data);
        }
        return error;
    }
};
